import {Component} from '@angular/core';

import {NgbModal, NgbModalOptions, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {BankAccountProvider} from "src/providers/company/bank_account/bank_account";
import {ContaBancariaDTO} from "src/model/dto/ContaBancariaDTO";
import {ErrorUtil} from "src/util/error";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {Snackbar} from "src/util/snackbar";
import {AuthProvider} from "src/providers/auth/authProvider";
import {FormBuilder, FormGroup, FormControl, Validators} from "@angular/forms";
import {ReplaySubject, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {CadastroContaBancariaComponent} from 'src/app/routes/minhasPropriedades/cadastro-conta-bancaria/cadastro-conta-bancaria.component';
import {ConvertObjectPipe} from "src/util/pipes/ConvertObjectPipe";
import {BatchProvider} from 'src/providers/batch/batchProvider';
import {Bookkeeping} from 'src/model/dto/bookkeping/Bookkeeping';
import Swal from 'sweetalert2';
import { CheckPermission } from 'src/service/checkPermission';


@Component({
    selector: 'app-editar-conta',
    templateUrl: './editar-conta.component.html',
    styleUrls: ['./editar-conta.component.scss']
  })

export class EditarContaComponent {
  closeResult = '';

  public contasBancarias: ContaBancariaDTO[];
  public enviando: boolean = false;
  public erroContas: boolean = false;
  public erro: string;
  public formPassword: FormGroup;
  public bankAccountFilterCtrl: FormControl = new FormControl();
  public filter_bankAccount: ReplaySubject<ContaBancariaDTO[]> = new ReplaySubject<ContaBancariaDTO[]>(1);
  protected _onDestroy = new Subject<void>();
  public lancamentoForm: FormGroup;
  public batchForm: FormGroup;
  public selectedBookkeeping: Bookkeeping[];

  constructor(public activeModal: NgbActiveModal,
              private modalService: NgbModal,
              private bank_accountProvider: BankAccountProvider,
              public errorUtil: ErrorUtil,
              private authProvider: AuthProvider,
              public snackbar: Snackbar,
              public formBuilder: FormBuilder,
              private batchProvider: BatchProvider,
              public checkPermission: CheckPermission) {
                this.getBanksAccounts();
                this.formPassword = this.formBuilder.group({
                  password: [null, Validators.required],
                });
                this.batchForm = this.formBuilder.group({
                  conta: [null, Validators.required]
                });
              }

  open(content) {
    let modalOptions: NgbModalOptions = {
      backdrop: 'static',
      ariaLabelledBy: "modal-basic-title",
      windowClass: localStorage.getItem('theme') == 'dark'? 'dark-theme' : ''
    };
    this.modalService.open(content, modalOptions).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
    //   this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  async getBanksAccounts() {
    await this.bank_accountProvider.getAllBanksAccounts().then((contasBancarias: ContaBancariaDTO[]) => {
      this.contasBancarias = contasBancarias;
      // this.novaConsultaContaBancaria();
      this.erroContas = false;
      this.initializeSearchSelect();
    }).catch((result: HttpErrorResponse) => {
      this.erroContas = true;
      this.erro = this.errorUtil.checkErrorStatus(result, result.status, result.error, 'bankAccount');
    });
  }

  async onYesClick() {
    this.enviando = true;
    if(this.batchForm.valid) {
      this.enviando = true;
      await this.authProvider.revalidateLogin(this.formPassword.value.password).then(async value => {
        let bookkeepingIds = this.selectedBookkeeping.map(b => b.id);
        await this.batchProvider.postContaMovimento(bookkeepingIds, this.batchForm.value.conta.id).then((result: []) => {
          this.enviando = false;
          if(result.length == this.selectedBookkeeping.length && result.length != 0) {
            Swal.fire({
              title: 'Sucesso!',
              text: 'Os lançamentos selecionados foram alterados com sucesso!',
              icon: 'success'
            });
          } else if(result.length > this.selectedBookkeeping.length && result.length != 0) {
            Swal.fire({
              title: 'Atenção!',
              text: 'Foi solicitada alteração em ' + (this.selectedBookkeeping.length) + ' lançamentos, porém, somente ' + (result.length) + ' foram alterados.',
              icon: 'warning'
            });
          } else if(result.length == 0) {
            Swal.fire({
              title: 'Erro!',
              text: 'Nenhum lançamento foi alterado',
              icon: 'error'
            });
          }
          this.activeModal.close(result);
        }).catch((response: HttpErrorResponse) => {
          this.enviando = false;
          this.activeModal.dismiss();
          if(response.error.error_description.includes("There is blocked periods")) {
            Swal.fire({
              title: 'Atenção!',
              text: 'Há lançamentos cadastrados dentro de um bloqueio de período. ' +
                     (this.checkPermission.isAccountantAdmin() ?
                     'Remova o bloqueio para poder alterar uma escrituração com um lançamento nesta data.' :
                     'Contate um administrador para que o bloqueio seja removido.'),
              icon: 'error'
            });
          } else {
            Swal.fire({
              title: 'Erro!',
              text: 'Nenhum lançamento foi alterado. Houve um erro de conexão com o servidor!',
              icon: 'error'
            });
          }
        });
      }).catch(reason => {
        this.enviando = false;
        this.activeModal.dismiss();
        Swal.fire({
          title: 'Falha na autenticação',
          text: 'Não foi possível alterar os lançamentos. Ocorreu um problema na autenticação!',
          icon: 'error'
        });
      });
    }

    this.enviando = false;
  }

  protected filterBankAccounts() {
    if (!this.contasBancarias) {
      return;
    }
    let search = this.bankAccountFilterCtrl.value;
    if (!search) {
      this.filter_bankAccount.next(this.contasBancarias.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filter_bankAccount.next(
      this.contasBancarias.filter(value => value.description.toLowerCase().indexOf(search) > -1)
    );
  }

  initializeSearchSelect() {
    this.contasBancarias.sort((a, b) => parseInt(a.code) - parseInt(b.code));
    this.filter_bankAccount.next(this.contasBancarias.slice());
    this.bankAccountFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBankAccounts();
      });
  }

  newOptionSelect(index) {
    this.openModalNewOption(CadastroContaBancariaComponent, this.contasBancarias, 'contabancaria', index);
  }

  openModalNewOption(modalName, list, filtered, index) {
    let modalOptions: NgbModalOptions = {
      backdrop: 'static',
      windowClass: localStorage.getItem('theme') == 'dark'? 'dark-theme' : ''
    };
    const modalRef = this.modalService.open(modalName, modalOptions);
    modalRef.result.then((result) => {
      let pipe = new ConvertObjectPipe();
        list.push(result);
        this.initializeSearchSelect();
      }, () => {
    });
  }

  // close(){ this.modalService.dismissAll(); }
}
